import { ReactNode } from 'react';
import { AppShell } from '@mantine/core';
import { useDocumentTitle } from '@/lib/pageTitle';

export function Basic({ children }: { children: ReactNode }) {
  useDocumentTitle();

  return (
    <AppShell
      header={{ height: 4 }}
      padding="md"
      transitionDuration={500}
      transitionTimingFunction="ease"
    >
      <AppShell.Main>{children}</AppShell.Main>
    </AppShell>
  );
}
